import _define_property from "@swc/helpers/src/_define_property.mjs";
import { Region } from "@core/api";
import { ENVIRONMENT } from "@core/configuration";
var _obj;
var devEndpoints = (_obj = {}, _define_property(_obj, ENVIRONMENT.dev, "https://analyticsdev.cloud.coveo.com/amplitude2/2/httpapi"), _define_property(_obj, ENVIRONMENT.stg, "https://analyticsstg.cloud.coveo.com/amplitude2/2/httpapi"), _obj);
var _obj1;
var productionEndpoints = (_obj1 = {}, _define_property(_obj1, Region.AU, "https://analytics-au.cloud.coveo.com/amplitude2/2/httpapi"), _define_property(_obj1, Region.CA, "https://analytics-ca.cloud.coveo.com/amplitude2/2/httpapi"), _define_property(_obj1, Region.EU, "https://analytics-eu.cloud.coveo.com/amplitude2/2/httpapi"), _define_property(_obj1, Region.US, "https://analytics.cloud.coveo.com/amplitude2/2/httpapi"), _obj1);
var PLATFORM_PRODUCTION_TRIALS_API_KEY = "342cfdda63cf76c0f5fa27b9f8ebe872";
var PLATFORM_PRODUCTION_API_KEY = "ca3fa6dad2eedb6588d222ba9ac951ec";
var PLATFORM_DEV_API_KEY = "4da23bb5da35c67ae251db13bfa0ba44";
export var AmplitudeConstant = {
    devEndpoints: devEndpoints,
    productionEndpoints: productionEndpoints,
    apiKey: {
        platformProductionTrials: PLATFORM_PRODUCTION_TRIALS_API_KEY,
        platformProduction: PLATFORM_PRODUCTION_API_KEY,
        platformDev: PLATFORM_DEV_API_KEY
    }
};

//# sourceMappingURL=AmplitudeConstant.js.map